import api from '@/api/api'

class StaticPageService {
  getPage(slug) {
    return api.axios.get('static-page/' + slug).then(response => response.data.page);
  }
}

export default new StaticPageService();
